import { createNode, DurationDataType } from '@glueapp/graph-types';
import { toDuration, fromDuration } from '../../utils/temporal';

export const AddDurations = createNode({
    id: 'Add Durations',
    name: 'Add Durations',
    description: 'Adds two Duration values together',
    aiDescription: 'Takes two Duration values on the "First" and "Second" ports and outputs their sum as a Duration on the "Result" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        First: DurationDataType,
        Second: DurationDataType,
    },
    outPorts: {
        Result: DurationDataType,
    },
    execute: function (input) {
        const first = toDuration(input.inPorts.First);
        const second = toDuration(input.inPorts.Second);
        const result = first.add(second);
        return { output: { Result: fromDuration(result) } };
    },
});
